define([
  "jquery",
  "globals"],
function($, globals) {

  "use strict";

  var Autocomplete = function() {

    var substringMatcher = function(strs) {
      return function findMatches(q, cb) {
        var matches, substrRegex;

        // an array that will be populated with substring matches
        matches = [];

        // regex used to determine if a string contains the substring `q`
        substrRegex = new RegExp(q, "i");

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function (i, str) {
          if (substrRegex.test(str.label)) {
            matches.push(str);
          }
        });

        cb(matches);
      };
    };

    var getData = function() {
      return $.ajax("/infopage/_autocomplete.js").done(function(data) {
        return JSON.parse(data);
      });
    }

    return {
      getData: getData,
      substringMatcher: substringMatcher
    }

  };

  return Autocomplete;

});
